import React from 'react';

const getProps = (currentProps, isAnimating, autoStart, beginAnimation, afterOpen) => (
  Object.assign({}, currentProps, {
    isAnimated: true,
    isAnimating,
    afterOpen: autoStart ? beginAnimation : afterOpen,
  })
);

const withAnimation = (WrappedComponent, autoStart) => (
  class AnimatedModal extends WrappedComponent {
    constructor(props) {
      super(props);
      this.beginAnimation = this.beginAnimation.bind(this);
      this.renderChildren = this.renderChildren.bind(this);
      this.state = {
        isModalOpen: this.props.activeModal === this.props.modalType,
        isAnimating: this.props.isAnimating,
      };
    }

    componentWillReceiveProps(nextProps) {
      if (this.props.modalType === nextProps.activeModal) {
        this.setState({
          isModalOpen: true,
        });
      } else {
        this.setState({
          isModalOpen: false,
          isAnimating: false,
        });
      }
    }

    beginAnimation() {
      this.setState({ isAnimating: true });
    }

    renderChildren() {
      return React.Children.map(this.props.children, child => (
        React.cloneElement(child, { isAnimating: this.state.isAnimating })
      ));
    }

    render() {
      return (
        <WrappedComponent
          {...getProps(
            this.props,
            this.state.isAnimating,
            autoStart,
            this.beginAnimation,
            this.props.afterOpen,
          )}
        >
          {this.props.children}
        </WrappedComponent>
      );
    }
  }
);

export default withAnimation;



// WEBPACK FOOTER //
// ./src-react/Modals/enhancers/AnimateModal.jsx